const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const ASSISTANT_ENDPOINTS = {
  /** One turn of the chat. Behind the server's own switch (ASSISTANT_ENABLED). */
  CHAT: `${API_URL}/assistant/chat`,
  /** { enabled }: whether the chat answers this person, so the app can offer it. */
  ACCESS: `${API_URL}/assistant/access`,
} as const;

export default ASSISTANT_ENDPOINTS;
